module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Dashboard.fed31ad4.svg";